<template>
  <footer class="footer px-4 mx-2">
    <b-row align-v="center" class="justify-content-lg-between">
      <b-col lg="6">
        <div class="copyright text-center text-lg-left text-muted">
          © {{year}} <a href="https://schulligen.de" class="font-weight-bold ml-1" target="_blank">CS Consulting GmbH & Co. KG</a>
        </div>
      </b-col>
      <b-col lg="6">
        <b-nav align="center" class="nav-footer justify-content-lg-end">
          <b-nav-item href="https://schulligen.de"  target="_blank">
            Entwicklung
          </b-nav-item>
          <b-nav-item href="https://schulligen.de" target="_blank">
           Über uns
          </b-nav-item>
          <b-nav-item href="https://schulligen.de" target="_blank">
            FAQ
          </b-nav-item>
        </b-nav>
      </b-col>
    </b-row>
  </footer>
</template>
<script>
export default {
  data() {
    return {
      year: new Date().getFullYear()
    };
  }
};
</script>
<style></style>
